import React from "react";
import "./App.css";

function App() {
  return (
    <div className="under-construction">
      <div className="content">
        <h1>🚧 Gigs.pk is Under Construction 🚧</h1>
        <p>We’re currently working on something awesome.</p>
        <p>We’ll be back in a week!</p>
      </div>
    </div>
  );
}

export default App;
